export default {
  components_Sunday: '日',
  components_Monday: '一',
  components_Tuesday: '二',
  components_Wednesday: '三',
  components_Thursday: '四',
  components_Friday: '五',
  components_Saturday: '六',
  components_browser_not_support_canvas: '您的浏览器不支持canvas标签。',
  components_expression: '表情',
  components_make_comment: '我来评一句',
  components_reply: '回复{name}:',
  components_reply_btn:'回复',
  components_year_mouths: "YYYY年 MM月",
  components_all_loaded: '已全部加载完毕',
  components_Loading: '正在加载',
  components_current_page_size:'找到{total}条记录, 显示{start}到{end}条',
  components_many_attempts:'尝试次数过多，请重新验证',
  components_many_refresh:'刷新次数过多，请重新验证',
  components_upload_files_empty:'上传文件为空，请重新选择',
  components_file_size_limit:"单个文件不能超过{limitSize}M，请重新选择",
  components_upload_time_out:'上传超时！',
  components_net_error:"网络错误！",
  components_uploading:"上传中...",
  components_uploadNumLimit:"最多支持上传{limit}个文件",
  components_most_num_limit:'一次最多上传{limit}个文件',
  components_single_num_limit:'单次最多上传{limit}个文件，请重新选择',
  components_upload_failed:'文件上传失败！',
  components_files_time_out:'文件上传超时！',
  components_select_file:'选择文件',
  components_limit_num_types:'可上传不超过{limit}个附件，格式支持：word、excel、ppt、pdf、jpg、png，每个文件大小为{limitSize}M以内。',
  components_please_upload_again:'上传文件为空，请重新上传',
  components_file_format_match:'文件格式不符，请检查后重试',
  components_limit_size_tip:'上传文件不得大于{limitSize}M，请重新上传',

}
